/*
 * "Complete your setup" add-on upsell + 2-pack card behaviour.
 *
 * Add-on rows each have a "+ Add" button that adds that accessory straight to
 * the cart and opens the drawer. The 2-pack card's button adds the configured
 * case and sends the shopper to the cases collection.
 *
 * Document-level event delegation so it survives the product section being
 * re-rendered via the Section Rendering API (inline scripts wouldn't).
 */
(function () {
  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function openCartDrawer() {
    var openers = document.querySelectorAll('[data-sidebar-id="CartDrawer"]');
    var opened = false;
    openers.forEach(function (o) {
      if (!opened && o.offsetParent !== null) { o.click(); opened = true; }
    });
    if (!opened && openers[0]) openers[0].click();
  }

  function refreshDrawer(sectionId, sections) {
    if (!sectionId || !sections || !sections[sectionId]) return;
    var wrap = document.getElementById('shopify-section-' + sectionId);
    if (!wrap) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = sections[sectionId];
    var inner = tmp.querySelector('#shopify-section-' + sectionId);
    wrap.innerHTML = inner ? inner.innerHTML : sections[sectionId];
  }

  // Build the case line item from the product form (keeps variant, quantity,
  // line-item properties and selling plan so personalised products still work).
  function caseLineItem(form) {
    var fd = new FormData(form);
    var item = {id: fd.get('id'), quantity: Number(fd.get('quantity') || 1)};
    var props = {};
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = value;
    });
    if (Object.keys(props).length) item.properties = props;
    var sellingPlan = fd.get('selling_plan');
    if (sellingPlan) item.selling_plan = sellingPlan;
    return item;
  }

  function addToCart(items) {
    var root = cartRoot();
    var drawer = document.querySelector('cart-drawer');
    var sectionId = drawer ? drawer.getAttribute('data-section-id') : null;
    var body = {items: items};
    if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return {ok: r.ok, data: data}; }); })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status)) {
          throw new Error((res.data && res.data.description) || 'add failed');
        }
        refreshDrawer(sectionId, res.data.sections);
        openCartDrawer();
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      });
  }

  // Add-on "+ Add" — add this accessory to the cart.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-fbt-add-item]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var id = btn.getAttribute('value');
    if (!id) return;

    var label = btn.querySelector('[data-fbt-add-label]');
    var original = label ? label.innerHTML : null;
    btn.disabled = true;

    addToCart([{id: id, quantity: 1}])
      .then(function () {
        btn.classList.add('is-added');
        if (label) label.textContent = '✓ Added';
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (label && original !== null) label.innerHTML = original;
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        if (label && original !== null) label.innerHTML = original;
        btn.disabled = false;
      });
  });

  // The 2-pack card is an informational nudge only (no button). Its progress
  // bar / status is rendered by Liquid on load and kept live by syncTwopack
  // below as cases are added elsewhere (main ATC, drawer). The main product
  // "Add To Cart" handles adding the case; the cart drawer pushes the 2nd.

  // Payment-methods popup: open/close the modal.
  function closePayModals() {
    document.querySelectorAll('[data-paymethods-modal]').forEach(function (m) { m.hidden = true; });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-paymethods-open]')) {
      e.preventDefault();
      var modal = document.querySelector('[data-paymethods-modal]');
      if (modal) { modal.hidden = false; document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-paymethods-close]')) {
      e.preventDefault();
      closePayModals();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.querySelector('[data-paymethods-modal]:not([hidden])')) {
      closePayModals();
    }
  });

  // Cycle the perks-bar message through msgs (fade every 3.5s). Timer is stored
  // on the element so re-syncs / drawer re-renders don't stack timers.
  function rotatePerksMessage(bar, msgs) {
    var el = bar.querySelector('[data-perks-message]');
    if (!el) return;
    if (bar.__perksTimer) { clearInterval(bar.__perksTimer); bar.__perksTimer = null; }
    el.style.opacity = '1';
    el.textContent = msgs[0];
    if (msgs.length < 2) return;
    var i = 0;
    bar.__perksTimer = setInterval(function () {
      if (!document.body.contains(bar)) { clearInterval(bar.__perksTimer); return; }
      i = (i + 1) % msgs.length;
      el.style.opacity = '0';
      setTimeout(function () { el.textContent = msgs[i]; el.style.opacity = '1'; }, 300);
    }, 3500);
  }

  // Keep the 2-pack button AND the two-tier perks bar in sync with the cart.
  function syncTwopack() {
    if (!document.querySelector('[data-twopack]') && !document.querySelector('[data-perks-bar]')) return;
    var accessories = ['creedlink-phone-tether', 'skiingcreed-screenprotector'];
    fetch(cartRoot() + 'cart.js', {headers: {'Accept': 'application/json'}})
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var caseQty = 0;
        (cart.items || []).forEach(function (it) {
          if (accessories.indexOf(it.handle) === -1) caseQty += it.quantity;
        });

        // Two-tier perks bar (mid = free shipping @ 2 items, end = discount @ 2
        // cases). The MESSAGE shows one step at a time. Strings mirror
        // snippets/free-shipping-bar.liquid.
        document.querySelectorAll('[data-perks-bar]').forEach(function (bar) {
          var save = bar.getAttribute('data-perks-save') || '$12';
          var n = cart.item_count, pct, msg;
          if (caseQty >= 2) {
            pct = 100;
            msg = 'Free shipping + ' + save + ' off unlocked ✓';
          } else if (n >= 2) {
            pct = caseQty === 1 ? 75 : 60;
            msg = caseQty === 1 ? 'Add 1 more case to save ' + save : 'Add 2 cases to save ' + save;
          } else if (n === 1) {
            pct = 25;
            msg = 'Add 1 more item for free shipping';
          } else {
            pct = 0;
            msg = 'Add 2 items for free shipping';
          }
          var fill = bar.querySelector('[data-perks-fill]');
          if (fill) fill.style.width = pct + '%';
          rotatePerksMessage(bar, [msg]);
          var mid = bar.querySelector('[data-perks-mid]');
          if (mid) mid.classList.toggle('is-done', n >= 2 || caseQty >= 2);
          var end = bar.querySelector('[data-perks-end]');
          if (end) end.classList.toggle('is-done', caseQty >= 2);
        });

        document.querySelectorAll('[data-twopack]').forEach(function (card) {
          var save2 = card.getAttribute('data-2pack-save') || '€12';
          card.classList.toggle('is-complete', caseQty >= 2);
          var fill = card.querySelector('[data-2pack-fill]');
          if (fill) fill.style.width = Math.min(100, caseQty * 50) + '%';
          var status = card.querySelector('[data-2pack-status]');
          if (status) {
            if (caseQty >= 2) status.textContent = '✓ You saved ' + save2 + '!';
            else if (caseQty === 1) status.textContent = '1 of 2 — add 1 more to save ' + save2 + '!';
            else status.textContent = 'Add 2 cases to unlock ' + save2 + ' off';
          }
        });
      })
      .catch(function () {});
  }

  // Keep the 2-pack button in sync with EVERY cart change (add, remove, qty)
  // by observing cart-mutating fetches the theme makes.
  if (window.fetch && !window.__twopackFetchPatched) {
    window.__twopackFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var u = (typeof input === 'string') ? input : (input && input.url) || '';
      var pr = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(u)) {
        // twice: once fast, once after the theme's own drawer re-render
        // (which replaces the perks-bar HTML and would undo the first sync)
        pr.then(function () { setTimeout(syncTwopack, 300); setTimeout(syncTwopack, 1300); }).catch(function () {});
      }
      return pr;
    };
  }
  document.addEventListener('cart:refresh', syncTwopack);
  // the drawer body is stamped from a <template> on first open — sync right
  // after so the perks bar reflects the current cart, not the page-load cart
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-sidebar-id="CartDrawer"]')) {
      setTimeout(syncTwopack, 450);
    }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncTwopack);
  } else {
    syncTwopack();
  }
})();
